import Table from './Table';
import Column from './Column';
import ColumnGroup from './ColumnGroup';

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

export default Table;
export { Column, ColumnGroup };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-table@6.1.12@rc-table/es/index.js
// module id = null
// module chunks = 